import type {PublicMethodUtils} from '@wix/document-services-types'
import type {HistoryPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<HistoryPublicAPI> {
    return {
        methods: {
            history: {
                clear: publicMethodUtils.extensionPublicAPI.immediate('undoRedo.clear'),
                add: publicMethodUtils.extensionPublicAPI.dataManipulation('undoRedo.executeAdd', {
                    getImmediatePreDataManipulationMethodPath: 'undoRedo.preAdd',
                    noBatchingAfter: true
                }),
                captureCheckpoint: publicMethodUtils.extensionPublicAPI.immediate('undoRedo.captureCheckpoint'),
                revertToCheckpoint: publicMethodUtils.extensionPublicAPI.immediate('undoRedo.revertToCheckpoint'),
                addWithCheckpointIfNeeded: publicMethodUtils.extensionPublicAPI.dataManipulation(
                    'undoRedo.executeAddWithCheckpointIfNeeded',
                    {
                        getImmediatePreDataManipulationMethodPath: 'undoRedo.preAddWithCheckpointIfNeeded',
                        noBatchingAfter: true
                    }
                ),
                undo: publicMethodUtils.extensionPublicAPI.dataManipulation('undoRedo.executeUndo', {
                    getReturnValueMethodPath: 'undoRedo.returnValueForUndo',
                    getImmediatePreDataManipulationMethodPath: 'undoRedo.preUndo',
                    noBatching: true
                }),
                redo: publicMethodUtils.extensionPublicAPI.dataManipulation('undoRedo.executeRedo', {
                    getReturnValueMethodPath: 'undoRedo.returnValueForRedo',
                    getImmediatePreDataManipulationMethodPath: 'undoRedo.preRedo',
                    noBatching: true
                }),
                canUndo: publicMethodUtils.extensionPublicAPI.getter('undoRedo.canUndo'),
                canRedo: publicMethodUtils.extensionPublicAPI.getter('undoRedo.canRedo'),
                getUndoLastSnapshotParams: publicMethodUtils.extensionPublicAPI.getter(
                    'undoRedo.getUndoLastSnapshotParams'
                ),
                getUndoLastSnapshotLabel: publicMethodUtils.extensionPublicAPI.getter(
                    'undoRedo.getUndoLastSnapshotLabel'
                ),
                getRedoLastSnapshotParams: publicMethodUtils.extensionPublicAPI.getter(
                    'undoRedo.getRedoLastSnapshotParams'
                ),
                getRedoLastSnapshotLabel: publicMethodUtils.extensionPublicAPI.getter(
                    'undoRedo.getRedoLastSnapshotLabel'
                ),
                getCurrentSnapshotId: publicMethodUtils.extensionPublicAPI.getter('undoRedo.getCurrentSnapshotId'),
                hasChangesSinceSnapshot: publicMethodUtils.extensionPublicAPI.getter(
                    'undoRedo.hasChangesSinceSnapshot'
                ),
                applyLatestSnapshot: publicMethodUtils.extensionPublicAPI.dataManipulation(
                    'undoRedo.executeApplyLatestSnapshot',
                    {
                        getImmediatePreDataManipulationMethodPath: 'undoRedo.preApplyLatestSnapshot',
                        noBatchingAfter: true
                    }
                ),
                getUndoLastSnapshotId: publicMethodUtils.extensionPublicAPI.getter('undoRedo.getUndoLastSnapshotId'),
                getRedoLastSnapshotId: publicMethodUtils.extensionPublicAPI.getter('undoRedo.getRedoLastSnapshotId')
            }
        }
    }
}
